import {useQuery} from "@tanstack/react-query";
import {getBanners} from "../../api/utils";
import {BANNER_GROUP_MAIN} from "../../Config";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function Banners() {
    const {data: banners} = useQuery({
        queryKey: ['banners', BANNER_GROUP_MAIN],
        queryFn: () => getBanners(BANNER_GROUP_MAIN)
    });

    const activeBanners = banners?.filter(b => b.is_active);

    if (!activeBanners?.length) return null;

    return (
        <div className="about__img">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                navigation={activeBanners.length > 1}
                pagination={activeBanners.length > 1 ? {clickable: true} : false}
                loop={activeBanners.length > 1}
                autoplay={activeBanners.length > 1 ? {delay: 5000, disableOnInteraction: false} : false}
            >
                {activeBanners.map((banner, index) => (
                    <SwiperSlide key={index}>
                        <picture>
                            {banner.url
                                ? <a href={banner.url}><img className="w-100" src={'https://www.pride.ru' + banner.image_with_path} alt=""/></a>
                                : <img className="w-100" src={'https://www.pride.ru' + banner.image_with_path} alt=""/>
                            }
                        </picture>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
